import { useEffect, useSyncExternalStore } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isDevMode, setDevMode } from '@/lib/dev-settings';

function subscribe(callback: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener('ienone:dev-mode-changed', callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener('ienone:dev-mode-changed', callback);
    window.removeEventListener('storage', callback);
  };
}

export function useDevMode(): boolean {
  const [params] = useSearchParams();
  const dev = useSyncExternalStore(subscribe, isDevMode, () => false);

  useEffect(() => {
    const flag = params.get('dev');
    if (flag === '1' && !isDevMode()) setDevMode(true);
    if (flag === '0' && isDevMode()) setDevMode(false);
  }, [params]);

  return dev;
}

export function disableDevMode(): void {
  setDevMode(false);
}
